"use client";

import Image from "next/image";
//import { Tooltip as ReactTooltip } from "react-tooltip";
//import "react-tooltip/dist/react-tooltip.css";

export default function RegulatoryInfo() {

    return (
        <div className="/*bg-bluebirdlightblue*/">
            <h1 className="text-4xl p-4 pl-12">Regulatory background, barriers and best practices</h1>
            <p className="pl-12 pr-12 pb-4">
                BlueBird performs an in-depth analysis of the <strong>regulatory framework</strong> that enables or constrains the transformation of buildings into energy flexibility assets. 
                The analysis includes mapping relevant provisions in <strong>EU directives</strong> such as the recast Energy Performance of Buildings Directive (EPBD), Renewable Energy Directive (RED III), 
                Energy Efficiency Directive (EED), and the Electricity Market Design (EMD). 
            </p>
            <p className="pl-12 pr-12 pb-4">
                Pilot partners contribute insights on existing regulatory, economic, and legal barriers related to the national and regional implementation of these directives, 
                with a particular focus on the <strong>Smart Readiness Indicator</strong>, building systems, renewable energy, smart technologies, aggregators, and energy communities. This is complemented 
                with the identification of successful local policies that serve as good practices and enablers, assessing their potential applicability in other Member States.
            </p>
            <div className="relative w-full max-w-4xl mx-auto mb-8">
                {/* Wrapper for Image and Hotspots */}
                <div className="relative w-full">
                    {/* Main figure */}
                    <Image
                        src="/projectoverview/regulatory.png"
                        alt="Regulatory research"
                        width={900}
                        height={200}
                        className="object-cover"
                    />

                </div>
            </div>
        </div>
    )
}